<template>
  <span
    class="text-blue-grey flex items-center"
    data-testid="social-mention-engagement-sentiment"
  >
    <QIcon
      :name="sentiment.icon"
      size="18px"
      :style="{ color: sentiment.color }"
    />
    <BaseStreemTooltip>{{
      $t("social_mention_engagement_sentiment.automatically_rated_as", {
        sentiment: sentiment.label,
      })
    }}</BaseStreemTooltip>
  </span>
</template>

<script>
import { BaseStreemTooltip } from "shared/components/base";
import { sentimentOptions } from "shared/components/core/pickers/SentimentPicker";

export default {
  name: "SocialMentionEngagementSentiment",
  components: {
    BaseStreemTooltip,
  },
  props: {
    modelValue: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    sentiment() {
      return sentimentOptions.find((option) => option.inRange(this.modelValue));
    },
  },
};
</script>
